import { MenuItem, Tooltip, Typography } from '@material-ui/core'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import { useUserInfo } from 'shared/hooks'
import { getInitials } from 'shared/utils'
import { AVATAR_SIZE } from './constants'
import {
  Container,
  TextContentContainer,
  UserAvatar,
  Content,
  Dropdown,
  NameContainer,
} from './UserDropdown.style'
import { useDropdown, useOptions } from './UserDropdown.utils'

const NAME_TOOLTIP_TRESHOLD = 40
const ID_PREFIX = 'user-dropdown'

interface UserDropdownProps {}

const UserDropdown = (props: UserDropdownProps) => {
  const { anchorEl, handleClick, handleClose } = useDropdown()
  const {
    attributes: { avatarUrl, name },
    username,
  } = useUserInfo()

  const options = useOptions()
  const DropdownIcon = anchorEl ? ArrowDropUpIcon : ArrowDropDownIcon
  return (
    <Container>
      <Content onClick={handleClick}>
        {avatarUrl ? (
          <UserAvatar variant="circular" size={AVATAR_SIZE} src={avatarUrl} />
        ) : (
          <UserAvatar size={AVATAR_SIZE}>{getInitials(name)}</UserAvatar>
        )}
        <TextContentContainer id={`${ID_PREFIX}-details`}>
          <div>
            <NameContainer>
              <Tooltip
                PopperProps={{ disablePortal: true }}
                title={name.length > NAME_TOOLTIP_TRESHOLD ? name : ''}
              >
                <Typography>{name}</Typography>
              </Tooltip>
            </NameContainer>
            <DropdownIcon />
          </div>
          <Typography>{username}</Typography>
        </TextContentContainer>
      </Content>
      <Dropdown
        onClose={handleClose}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        {options.map(({ title, onClick }, idx) => (
          <MenuItem key={`user-dropdown-item-${idx}`} button onClick={onClick}>
            <Typography>{title}</Typography>
          </MenuItem>
        ))}
      </Dropdown>
    </Container>
  )
}
export default UserDropdown
